'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Textfield } from '../../components/input-with-validation';
import { DEFAULT_ERROR_MESSAGE } from '../b2b-funnel-embed.consts';
import styles from './shared-styles.module.scss';
export const ContactPersonStep = ({ funnelState })=>{
    const firstNameError = funnelState?.errors?.contactPerson?.firstName;
    const lastNameError = funnelState?.errors?.contactPerson?.lastName;
    const phoneNumberError = funnelState?.errors?.contactPerson?.phoneNumber;
    return /*#__PURE__*/ _jsxs("div", {
        className: styles['funnel-step'],
        children: [
            /*#__PURE__*/ _jsx(Textfield, {
                className: styles['input-spacing'],
                defaultValue: funnelState.formValues.firstName,
                name: "firstName",
                placeholder: "Vorname",
                statusLabel: firstNameError ?? ' ',
                statusType: firstNameError ? 'error' : 'default',
                messages: {
                    minLength: DEFAULT_ERROR_MESSAGE
                },
                minLength: 2,
                required: true
            }),
            /*#__PURE__*/ _jsx(Textfield, {
                defaultValue: funnelState.formValues.lastName,
                name: "lastName",
                placeholder: "Nachname",
                statusLabel: lastNameError ?? ' ',
                statusType: lastNameError ? 'error' : 'default',
                messages: {
                    minLength: DEFAULT_ERROR_MESSAGE
                },
                minLength: 2,
                required: true
            }),
            /*#__PURE__*/ _jsx(Textfield, {
                defaultValue: funnelState.formValues.phoneNumber,
                name: "phoneNumber",
                placeholder: "Telefonnummer",
                statusLabel: phoneNumberError,
                statusType: phoneNumberError ? 'error' : 'default',
                type: "tel",
                pattern: "^(?:\\+\\d|0)(?: ?(- ?)?\\d){5,}$",
                required: true
            })
        ]
    });
};

//# sourceMappingURL=contact-person.js.map